import { Typography, Carousel, theme } from "kosmos-ui/lib";
import reactParser from "html-react-parser";

import { useGetRecommendationsQuery } from "api/graphql/queries/recommendations/hooks";
import { useLayout } from "app/context/LayoutContext/hooks";
import RecommendationItemCard from "app/components/RecommendationItemCard";

import {
  RecommendationsContainer,
  RecommendationContainer,
  RecommendationsGridContainer,
} from "./styles";

export default function HomeRecommendations() {
  const { mobile } = useLayout();

  const { data: recommendationsData, loading: loadingRecommendations } =
    useGetRecommendationsQuery();

  const recommendations = recommendationsData?.getRecommendations;

  return (
    <RecommendationsContainer>
      {loadingRecommendations ? (
        <p>Cargando recomendaciones...</p>
      ) : (
        recommendations?.map((recommendation, index) => {
          const recommendationItems = recommendation.items.edges;
          const recommendationDescription =
            recommendation.description &&
            reactParser(recommendation.description);

          return (
            <RecommendationContainer key={recommendation._id}>
              <Typography
                as="h1"
                variant="title3"
                style={{ color: theme.colorsPalette.white.default }}
              >
                {recommendation.name}
              </Typography>

              {recommendationDescription && (
                <Typography
                  as="h2"
                  variant="paragraph1"
                  style={{ marginTop: -8 }}
                >
                  {recommendationDescription}
                </Typography>
              )}

              {recommendation.render.container === "carousel" ? (
                <Carousel
                  withArrows
                  slidesAtOnce={
                    mobile
                      ? 1
                      : recommendation.render.items === "article"
                      ? 5
                      : 4
                  }
                  style={{
                    root: {
                      height:
                        recommendation.render.items === "article" ? 316 : 216,
                      marginBottom:
                        index !== recommendations.length - 1 ? 40 : 0,
                    },
                  }}
                >
                  {recommendationItems.map((recommendationItem, index) => (
                    <Carousel.Slide
                      key={`${recommendationItem.node._id}-${index}`}
                    >
                      <RecommendationItemCard
                        item={recommendationItem.node}
                        render={recommendation.render.items}
                        style={{ root: { marginRight: !mobile ? 16 : 0 } }}
                      />
                    </Carousel.Slide>
                  ))}
                </Carousel>
              ) : (
                <RecommendationsGridContainer>
                  {recommendationItems.map((recommendationItem, index) => (
                    <RecommendationItemCard
                      key={`${recommendationItem.node._id}-${index}`}
                      item={recommendationItem.node}
                      render={recommendation.render.items}
                    />
                  ))}
                </RecommendationsGridContainer>
              )}
            </RecommendationContainer>
          );
        })
      )}
    </RecommendationsContainer>
  );
}
